export class CandidatePersonalDataClass {
    firstName?: string;
    lastName?: string;
    currentWorkPosition?: string;
    currentSalary?: string;
    appliedOn?: string;
    liveIn?: string;
}
